import { GeoPoint } from '@common/contracts/server/ostin/api';

import { numToFixed } from '@/utils/helpers/number-utils';

const EARTH_RADIUS = 6371; // радиус земли

export const calcDistanceByCoords = ({
  x1, y1, x2, y2,
}: {
  x1: number, y1: number, x2: number, y2: number,
}) => Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

const degreesToRadians = (degrees: string|number) => (+degrees) * (Math.PI / 180); // градусы в радианы
const radiansToDegrees = (radians: string|number) => (+radians) * (180 / Math.PI); // радианы в градусы

// угл между двумя точками от центра сферы
const centralSubtendedAngle = (locationX: Required<GeoPoint>, locationY: Required<GeoPoint>) => {
  const locationXLatRadians = degreesToRadians(locationX.latitude);
  const locationYLatRadians = degreesToRadians(locationY.latitude);

  return radiansToDegrees(
    Math.acos(
      Math.sin(locationXLatRadians) * Math.sin(locationYLatRadians)
      + Math.cos(locationXLatRadians)
      * Math.cos(locationYLatRadians)
      * Math.cos(degreesToRadians(Math.abs((+locationX.longitude) - (+locationY.longitude)))),
    ),
  );
};

// расстояния между двумя точками с учетом центрального угла
const greatCircleDistance = (angle: number) => 2 * Math.PI * EARTH_RADIUS * (angle / 360);

// расстояние на поверхности сферы между двумя координатами
export const calcDistanceByLocations = (locationX: Required<GeoPoint>, locationY: Required<GeoPoint>) => (
  greatCircleDistance(centralSubtendedAngle(locationX, locationY))
);

export function getStoreDistance(userGeoCoords, store) {
  return numToFixed(calcDistanceByCoords({
    x1: userGeoCoords?.latitude,
    y1: userGeoCoords?.longitude,
    x2: store.geo?.latitude ?? store.geoPoint?.lat,
    y2: store.geo?.longitude ?? store.geoPoint?.lon,
  }), 3); // округляем до 3 знаков, т.к. показывает лучший результат сортировки
}
